import Gigya from './gigya.js'
import FidmOidc from './fidm.oidc.js'
import FidmSaml from './fidm.saml.js'

export * from './interfaces/gigya-response.js'
export * from './fidm.oidc.js'
export * from './fidm.saml.js'

export class Fidm {
	public readonly oidc: FidmOidc
	public readonly saml: FidmSaml

	constructor(protected gigya: Gigya) {
		this.oidc = new FidmOidc(gigya)
		this.saml = new FidmSaml(gigya)
	}
}

export default Fidm
